import { UUID } from "io-ts-types/lib/UUID"
import { v4 as uuid } from "uuid"
import { cast } from "@flockcover/flock-svc-core-types"

export const makeUUID = (id?: unknown) => cast(UUID)(id || uuid())

export default makeUUID
